<template>
<div class="logo-section">
  <h2 class="logo-title">Spolupracujeme</h2>
  <div class="logo-container">
    <div class="logo" v-for="logo in logos" :key="logo.id">
      <a :href="logo.url" target="_blank">
        <img :src="logo.src" :alt="logo.alt" />
      </a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      logos: [
/*         {
          id: 1,
          src: require("@/assets/logo/entomologicka_logo.png"),
          alt: "Česká společnost entomologická",
          url: "https://herp.cz/",
        },
        {
          id: 3,
          src: require("@/assets/logo/ornitologicka_logo.jpg"),
          alt: "Česká společnost ornitologická",
          url: "https://birdlife.cz/",
        },
        {
          id: 2,
          src: require("@/assets/logo/herpetologicka_logo.png"),
          alt: "Česká herpetologická společnost",
          url: "https://herp.cz/",
        },
        {
          id: 4,
          src: require("@/assets/logo/parazitologicka_logo.png"),
          alt: "Česká parazitologická společnost",
          url: "https://www.parazitologie.eu/",
        },
        {
          id: 5,
          src: require("@/assets/logo/arachnologicka_logo.png"),
          alt: "Česká arachnologická společnost",
          url: "https://www.arachnology.cz/",
        }, */
        {
          id: 6,
          src: require("@/assets/logo/rvs_logo.png"),
          alt: "Rada vědeckých společností ČR",
          label: "Jsme součástí",
          url: "http://rvs.paleontologie.cz/",
        },
        {
          id: 7,
          src: require("@/assets/logo/smart_emailing_logo.png"),
          alt: "Smartemailing",
          label: "Spolupracujeme",
          url: "https://www.smartemailing.cz/",
        },
      ],
    };
  },
};
</script>

<style scoped>
.logo-container {
  background-color: #fff;
  display: flex;
  flex-wrap: nowrap;

  padding-top: 10px;
  padding-bottom: 20px;
  justify-content: center;
}

.logo {
  margin: 10px;
  cursor: pointer;
}

img {
  max-width: 100%;
  max-height: 100px;
}

@media (max-width: 768px) {
  img {
    max-height: 100px;
  }

  .logo-container {
    flex-direction: column;
    align-items: center;
  }
}

img {
  transition: transform 0.2s ease-in-out;
}

img:hover {
  transform: scale(1.1);
}

.logo-section {
  background-color: #fff;
  border-top: 2px solid #eee;
  text-align: center;
  margin-top: 2rem;
}

.logo-title {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: #333333;
}
</style>
